const defaults = {
  inputData: '',
  delimiter: ',',
  includeHeaders: true,
  fields: '',
  quoteStrings: true,
};

export default defaults;
